<template>
  <div class="main">
    <slot />
    <PortalTarget
      name="fullscreen"
      multiple
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({ name: 'EmptyLayout' })
</script>
